/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_DriverInputs */

const en_road_dude_prompt_driver = /** @type {(inputs: Road_Dude_Prompt_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person`)
};

const zh_road_dude_prompt_driver = /** @type {(inputs: Road_Dude_Prompt_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人物`)
};

/**
* | output |
* | --- |
* | "Person" |
*
* @param {Road_Dude_Prompt_DriverInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_driver = /** @type {((inputs?: Road_Dude_Prompt_DriverInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_DriverInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_driver(inputs)
	return zh_road_dude_prompt_driver(inputs)
});
export { road_dude_prompt_driver as "road_dude.prompt.driver" }